import { ViewPayload } from '../../client/appTypings';
import { createAction } from '@reduxjs/toolkit';

export const playerViewFetchSuccessAction = createAction<ViewPayload>(
  'playerView/playerViewFetchSuccess'
);
